// Professions reference pack (GR/CY) — the 764-entry library from VÉRO v250, preserved as
// shared reference data: occupation suggestions, occupational risk class, product hints.
import data from './gr-cy.json' with { type: 'json' };
import { searchKey } from '../rules.ts';

export interface Profession { name: string; category: string; risk: 'low' | 'medium' | 'high'; hints: string[] }
export const PROFESSIONS = (data as { items: Profession[] }).items;
const BY_KEY = new Map(PROFESSIONS.map((p) => [searchKey(p.name), p]));
export function findProfession(name: string | null | undefined): Profession | undefined {
  return name ? BY_KEY.get(searchKey(name)) : undefined;
}
